<script setup lang="ts">
import { FIREWALL_RULES } from '@/config/targets'
import * as da from '@/strings/da'
import { useCopyButton } from '@/composables/useCopyButton'

const { state, copy } = useCopyButton(() => FIREWALL_RULES)
</script>

<template>
	<section>
		<h3 class="heading">{{ da.checklist.heading }}</h3>
		<p class="lede">{{ da.checklist.lede }}</p>

		<ul class="list">
			<li v-for="item in da.checklist.items" :key="item.text">
				<span class="box" aria-hidden="true">□</span>
				<span>
					{{ item.text }}
					<span v-if="item.note" class="note">{{ item.note }}</span>
				</span>
			</li>
		</ul>

		<button type="button" class="btn btn-tcx-outline btn-sm" @click="copy">
			{{ state === 'copied' ? da.checklist.copied : da.checklist.copy }}
		</button>

		<template v-if="state === 'failed'">
			<p class="copy-failed">{{ da.checklist.copyFailed }}</p>
			<pre class="rules">{{ FIREWALL_RULES }}</pre>
		</template>
	</section>
</template>

<style scoped>
.heading {
	font-size: 1.0625rem;
	font-weight: 700;
}

.lede {
	margin: 6px 0 0;
	max-width: 62ch;
	font-size: 0.875rem;
	color: var(--tcx-muted);
}

.list {
	margin: 14px 0 18px;
	padding: 0;
	list-style: none;
}

.list li {
	display: flex;
	gap: 10px;
	padding: 7px 0;
	font-size: 0.9375rem;
	max-width: 66ch;
}

.box {
	color: var(--tcx-teal);
	font-size: 1.125rem;
	line-height: 1.35;
}

.note {
	display: block;
	margin-top: 2px;
	font-size: 0.8125rem;
	color: var(--tcx-muted);
}

.copy-failed {
	margin: 12px 0 6px;
	font-size: 0.875rem;
	color: var(--tcx-text);
}

.rules {
	margin: 0;
	padding: 12px 14px;
	border: 1px solid var(--tcx-line);
	border-radius: var(--tcx-radius-sm);
	background: #fafbfb;
	font-size: 0.8125rem;
	white-space: pre-wrap;
	color: var(--tcx-text);
}
</style>
